import { GET } from "../../../helpers/restFunction";

const GetChat = async (userId: String, SupportId?: string) => {
  const path = `/cad/${userId}/cad_support_details/${SupportId}`;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
export default GetChat;
